import React from 'react';
import { Container, Row } from 'react-bootstrap';
import "./DayTimeOvernight.scss";
import featured_day_night from '../../Assets/img/service/Day-&-night-feature.jpg';
import logo_day_night from '../../Assets/img/day-night-care/logo.png';
import job_offers from '../../Assets/img/day-night-care/job-offers.png';
import welcomeHome from "../../Assets/img/day-night-care/welcomeHome.png";
import dayTimeCare from "../../Assets/img/day-night-care/dayTimeCare.png";
import nightTimeCare from "../../Assets/img/day-night-care/nightTimeCare.png";

import { Link, useNavigate } from 'react-router-dom';
import LockScreen from '../../Common/LockScreen/LockScreen';
import StreetCred from '../../Common/streetCred/streetCred';
import { CALL30MIN_URL, DAY_OF_DISCHARGE_URL } from '../../Utils/ServiceUrl';
import { HeroBannerHorizontal}  from '../../Common/HeroBanner';
import hero from '../../Assets/img/day-night-care/hero.png';
import heromobile from '../../Assets/img/day-night-care/hero-mobile.png';
import LandingDescription from '../../Common/LandingDescription';

const DayTimeOvernight = () => {
  let testimonialData = [
    {
      name: "PAUL M.",
      data: "I want to highlight the incredible service, character, and personality of everyone who came into our house. Every nurse was driven, professional, confident, well educated, in full control, and knowledgeable about all aspects of babies. It gave us such peace of mind. It also gave us a chance to ask those dumb questions we had stored up to a real nurse (like when our baby had delayed drop-off of the umbilical cord and it was freaking us out!)."
    },
    {
      name: "Carly W.",
      data: "This service absolutely saved my mental health from spiraling - a true life saver! Lauren entered our home and was immediately met with a new mom crying - she instantly addressed the issue, comforted me and let me know that this was normal and OK to be feeling this way. I am so thankful I scheduled this service and will absolutely recommend to anyone I know having their first baby or adding another child to their family. I had a list of questions to ask about me as well as my 8 day old baby, and Lauren answered them fully and in a way that made me feel empowered about the plan moving forward. My wife and I learned so much in the 4 hours Lauren spent with us, which made us feel so much more confident as new parents. Wish I could give 10 stars!"
    }
  ]
  const Navigate = useNavigate()
  return (
    <div className='daytime_overnight'>
      <Container fluid>
        <div className="py-3">
          <HeroBannerHorizontal
            hero={hero}
            mobileHero={heromobile}
            className="dayNightHeroBanner"
            mobileTitle={
              <>
              <div className="text-center">Awake all night <span className='strong'>so you <br /> don't have to be.</span></div>
              <button className="w-auto btn-small secondary-teal-btn-small mt-4" style={{fontWeight: "400!important;"}} onClick={() => Navigate(CALL30MIN_URL)}>Book a Free Info Call</button>
              </>
            }
            mobileMinHeight={450}
            width={90}
            title={
              <>
                <div>Awake all night <br /><span className='strong'>so you don't<br />have to be.</span></div>
                <h3>Over overnights? Let our Registered Nurses <br />and Postpartum Doulas take the night shift <br />so you can get some rest. </h3>
                <button className="w-auto btn-small secondary-teal-btn-small" style={{fontWeight: "400!important;"}} onClick={() => Navigate(CALL30MIN_URL)}>Book a Free Info Call</button>
              </>
            }
            afterBannerMobile={
              <>
                <p className='text-center'>Over overnights? Let our Registered Nurses <br />and Postpartum Doulas take the night shift <br />so you can get some rest. </p>
              </>
            }
          />
        </div>
        <Row>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <Container>
              <LandingDescription
                ySpace
                content={[
                  <>
                          <h3>This Isn’t Just Overnight Babysitting</h3>
                          <br />NAPS Overnight Nurses don’t just hold your baby while you sleep.
                          We stay awake all night observing feeding, sleep, digestion, and newborn patterns. Then actively guide your baby toward longer, more predictable stretches of sleep, naturally and safely.
                          Most families stop using our service not because they don’t need help, but because their baby is sleeping so well, they don’t need overnight support anymore. <br />
                  </>,
                ]}
              />
            </Container>
          </div>
        </Row>

        <Row className='pt-0 pb-5'>
          <div className='col-lg-12 col-md-12 my-3'>
            <Container fluid className='registered-nurse-main'>
              <Row className='justify-content-center'>
                <div className='col-lg-10 col-md-10'>
                  <Container>
                    <Row className='justify-content-center flex-column flex-md-row my-5'>
                      <div className='col-lg-5 col-md-5 col-sm-12 registered-nurse-imgsection '>
                        <img src={featured_day_night} className='img-fluid pe-4' />
                      </div>
                      <div className='col-lg-5 col-md-5 col-sm-12 py-5 registered-nurse-info'>
                        <div className='d-flex flex-column'>
                          <div>
                            <h3 className='text-center text-md-start'>
                              Who Overnight Care Is For
                            </h3>
                          </div>
                          <div>
                            <h5>Whether you’re: </h5>
                            <ul style={{listStyle: 'disc'}}>
                              <li>A first-time parent who hasn’t slept more than 90 minutes in weeks</li>
                              <li>An experienced parent who knows how brutal the newborn phase can be</li>
                              <li>Someone planning ahead to invest in your own physical and emotional wellbeing</li>
                              <li>Or a parent whose baby eats nonstop all night</li>
                            </ul>
                            <h5>We help families get real sleep, without crying it out or guessing your way through exhaustion.</h5>
                            <button className="w-auto btn-small secondary-teal-btn-small mt-2" onClick={() => Navigate(CALL30MIN_URL)}>Book a Free Info Call</button>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </Container>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

        <Row className='pale-bg offering-main'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <Container>
              <Row className="justify-content-center my-md-5 my-3 stage-offering-header">
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className="section-header text-center">
                    <h2 className="home-section-title py-0">Why a<span className="strong pink"> NAPS Nurse</span></h2>
                  </div>
                </div>
                <div className="col-lg-8 col-md-8 mt-2">
                  <h3 className="text-center stage-description">Families Choose <span className='strong'>NAPS Nurses</span> because we hold our team to the highest standards of expertise and quality care.</h3>
                </div>
              </Row>
            </Container>

            <Container className='offerings'>
              <div className="row my-3 my-lg-3 py-3 py-lg-5 col-reverse offer-row position-relative justify-content-center align-items-center">
                <div className="col-md-5 col-sm-12 order-1 order-md-0">
                  <div className="offering-block-content mt-4">
                    <h3 className="lh-1 mb-0 w-100 d-flex align-items-end justify-contnet-start">
                      <p className="d-md-inline-block d-block">
                        <span className="number pink">1. </span>
                        <span className="content">Certifications</span>
                        {/* <span className="cursive pink bestsellerv ms-3 Bestseller keep-all">Bestseller!</span> */}
                      </p>

                    </h3>
                    <p className="lh-md pb-1 pb-md-2 pe-0 pe-lg-4 h5">All NAPS overnight care is provided by Registered Nurses who are also Certified Postpartum Doulas, leading to evidence based care for both babies and parents. </p>
                  </div>
                </div>
                <div className="col-md-5 col-sm-12 order-0 order-md-1 position-relative">
                  <div className="offering-block-content pe-0 pe-lg-5">
                    <img src={welcomeHome} className='img-fluid' />
                  </div>
                </div>
              </div>

              <div className="row my-3 my-lg-3 py-3 py-lg-5 offer-row position-relative justify-content-center align-items-center">
                <div className="col-md-5 position-relative">
                  <div className="offering-block-content pe-0 pe-lg-4">
                    <img src={dayTimeCare} className='img-fluid' />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="offering-block-content mt-4">
                    <h3 className="lh-1 mb-0 w-100 d-flex align-items-end justify-contnet-start">
                      <p className="d-md-inline-block d-block">
                        <span className="number orange">2. </span>
                        <span className="content"> Experience</span>
                      </p>
                    </h3>
                    <p className="dark-grey lh-md h5">With over 14+ years of experience, our team excels at supporting families through feeding challenges, sleep struggles, postpartum recovery, and mental health transitions. </p>
                  </div>
                </div>
              </div>


              <div className="row my-3 my-lg-3 py-3 py-lg-5 col-reverse offer-row position-relative justify-content-center align-items-center">
                <div className="col-md-5 order-1 order-md-0">
                  <div className="offering-block-content mt-4">
                    <h3 className="lh-1 mb-0 consultations w-100">
                      <p className="d-md-inline-block d-block">
                        <span className="number lavender">3. </span>
                        <span className="content">Peace of Mind</span>
                      </p>
                    </h3>
                    <p className="dark-grey lh-md h5"> Every nurse is trained in maternal-child health and receives ongoing education in lactation, infant development, and family support, so you’re never handed off to someone who’s “just watching the baby.” </p>
                  </div>
                </div>
                <div className="col-md-5 order-0 order-md-1 position-relative">
                  <div className="offering-block-content pe-0 pe-lg-4">
                    <img src={nightTimeCare} className='img-fluid' />
                  </div>
                </div>
              </div>
            </Container>


            {/* </Container> */}
          </div>
        </Row>

        <Row className='pt-0 pb-5'>
          <div className='col-lg-12 col-md-12 my-3'>
            <Container fluid className='statistics'>
              <Row className='justify-content-center'>
                <div className='col-lg-10 col-md-10'>
                  <Container>
                    <Row className='justify-content-center flex-column flex-md-row my-5'>
                      <div className='col-lg-5 col-md-5 col-sm-12 registered-nurse-imgsection '>
                        <img src={job_offers} className='img-fluid pe-4' />
                      </div>
                      <div className='col-lg-5 col-md-5 col-sm-12 py-5 registered-nurse-info'>
                        <div className='d-flex flex-column text-center text-md-start'>
                          <div>
                            <h3>
                              You may already have money <span className='green strong'>to use for Overnight Care</span>
                            </h3>
                          </div>
                          <div>
                            <h5 className="text-white lh-sm py-3 px-0">Because all NAPS nurses are also Certified Postpartum Doulas, many families can use employer-sponsored benefits for care.</h5>
                            <h5 className="text-white lh-sm py-3 px-0">If your job offers a stipend for postpartum support through partners like Carrot, Maven, or Progyny, those funds often apply directly to NAPS overnight nursing.</h5>
                            <img src={logo_day_night} alt="" className='img-fluid pe-4 mx-auto mx-md-0 d-block' />
                            <div>
                                <button
                                  className='secondary-teal-btn-small mt-4'
                                  onClick={() => Navigate(CALL30MIN_URL)}
                                  style={{ display: 'inline-block', textAlign: 'center' }}
                                >
                                  Learn How To Use Your Benefit
                                </button>
                            </div>
                            </div>
                        </div>
                      </div>
                    </Row>
                  </Container>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

        {/* <LockScreen /> */}
        {/* <PodcastUI /> */}

        {/* any testimonial ui */}
        <StreetCred data={testimonialData} />

        
        <div className='col-lg-12 col-md-12 become-main'>
          <div className='become-member my-4'>
              <div className='container'>
                  <div className='col-lg-12 col-md-12'>
                      <div className='become-member-container p-0 p-md-5'>
                          <div className='row'>
                              <div className='col-lg-6 col-md-6 col-sm-12 ms-0 ms-md-5 me-0 me-md-5 order-1 order-md-0'>
                                  <div className='become-meber-captions'>
                                      <h3>Let’s Talk About 
                                          <span className="strong">Your Nights</span>
                                      </h3>
                                      <div className='text-white lh-sm py-3 px-0 px-md-5'>In a free 30-minute call, our team will:</div>
                                      <div>
                                          <ol>
                                              <li>Learn about your baby</li>
                                              <li>Walk through scheduling and pricing</li>
                                              <li>Check employer benefit eligibility</li>
                                              <li>Make sure this is actually the right fit</li>
                                          </ol>
                                      </div>
                                      <div className='text-white lh-sm py-3 px-0 px-md-5'>No pressure. Just real answers from real nurses.</div>
                                      <div>
                                          <button className='secondary-teal-btn-small mt-4' onClick={() => Navigate(CALL30MIN_URL)}>Book My Free Call</button>
                                      </div>
                                  </div>
                              </div>
                              <div className='col-lg-6 col-md-6 col-sm-12 mob-membership-img-container order-0 order-md-1'>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
                    
      </Container>
    </div>
  )
}

export default DayTimeOvernight;